import {connect} from 'react-redux';
import SupporterListScreen from '../../components/screens/SupporterListScreen';
import {
    getSupporters,
    paginate,
    searchStringChange,
    periodsFilterChange,
    statesFilterChange
} from '../../actions/supporterListAction';

const mapStateToProps = state => {
    return {
        supporters: state.supporterList.supporters,
        pagination: state.supporterList.pagination,
        searchString: state.supporterList.searchString,
        visibileSupportersAmount: state.supporterList.visibileSupportersAmount,
        availableStates: state.supporterList.availableStates,
        statesFilter: state.supporterList.statesFilter,
        availablePeriods: state.supporterList.availablePeriods,
        periodsFilter: state.supporterList.periodsFilter,
        addDialog: state.supporterList.addDialog
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getSupporters: () => {
            dispatch(getSupporters())
        },
        paginate: (offset) => {
            dispatch(paginate(offset))
        },
        searchStringChange: (searchString) => {
            dispatch(searchStringChange(searchString))
        },
        periodsFilterChange: (periodsFilter) => {
            dispatch(periodsFilterChange(periodsFilter))
        },
        statesFilterChange: (statesFilter) => {
            dispatch(statesFilterChange(statesFilter))
        }
    }
};

const SupporterListScreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SupporterListScreen);

export default SupporterListScreenContainer;